"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RU = void 0;
exports.RU = {
    numericCode: '643',
    alpha2Code: 'RU',
    alpha3Code: 'RUS',
    englishName: {
        short: 'Russian Federation (the)',
        full: 'the Russian Federation',
    },
    names: {
        full: {
            en: 'the Russian Federation',
            fr: 'la Fédération de Russie',
            ru: 'Rossijskaja Federacija',
        },
        short: {
            en: 'Russian Federation (the)',
            fr: 'Russie (la Fédération de)',
            ru: 'Rossijskaja Federacija',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'ru',
            languageAlpha3Code: 'rus',
            isAdministrative: true,
        },
    ],
    subdivisions: {
        'RU-AMU': {
            numericCode: '643',
            code: 'RU-AMU',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Amurskaja oblast'",
            },
        },
        'RU-ARK': {
            numericCode: '643',
            code: 'RU-ARK',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Arhangel'skaja oblast'",
            },
        },
        'RU-AST': {
            numericCode: '643',
            code: 'RU-AST',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Astrahanskaja oblast'",
            },
        },
        'RU-BEL': {
            numericCode: '643',
            code: 'RU-BEL',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Belgorodskaja oblast'",
            },
        },
        'RU-BRY': {
            numericCode: '643',
            code: 'RU-BRY',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Brjanskaja oblast'",
            },
        },
        'RU-CHE': {
            numericCode: '643',
            code: 'RU-CHE',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Chelyabinskaya oblast'",
            },
        },
        'RU-IRK': {
            numericCode: '643',
            code: 'RU-IRK',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Irkutskaja oblast'",
            },
        },
        'RU-IVA': {
            numericCode: '643',
            code: 'RU-IVA',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Ivanovskaja oblast'",
            },
        },
        'RU-KEM': {
            numericCode: '643',
            code: 'RU-KEM',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Kemerovskaja oblast'",
            },
        },
        'RU-KGD': {
            numericCode: '643',
            code: 'RU-KGD',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Kaliningradskaja oblast'",
            },
        },
        'RU-KGN': {
            numericCode: '643',
            code: 'RU-KGN',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Kurganskaya oblast'",
            },
        },
        'RU-KIR': {
            numericCode: '643',
            code: 'RU-KIR',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Kirovskaya oblast'",
            },
        },
        'RU-KLU': {
            numericCode: '643',
            code: 'RU-KLU',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Kaluzhskaya oblast'",
            },
        },
        'RU-KOS': {
            numericCode: '643',
            code: 'RU-KOS',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Kostromskaja oblast'",
            },
        },
        'RU-KRS': {
            numericCode: '643',
            code: 'RU-KRS',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Kurskaya oblast'",
            },
        },
        'RU-LEN': {
            numericCode: '643',
            code: 'RU-LEN',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Leningradskaya oblast'",
            },
        },
        'RU-LIP': {
            numericCode: '643',
            code: 'RU-LIP',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Lipetskaya oblast'",
            },
        },
        'RU-MAG': {
            numericCode: '643',
            code: 'RU-MAG',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Magadanskaja oblast'",
            },
        },
        'RU-MOS': {
            numericCode: '643',
            code: 'RU-MOS',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Moskovskaja oblast'",
            },
        },
        'RU-MUR': {
            numericCode: '643',
            code: 'RU-MUR',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Murmanskaja oblast'",
            },
        },
        'RU-NGR': {
            numericCode: '643',
            code: 'RU-NGR',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Novgorodskaya oblast'",
            },
        },
        'RU-NIZ': {
            numericCode: '643',
            code: 'RU-NIZ',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Nizhegorodskaya oblast'",
            },
        },
        'RU-NVS': {
            numericCode: '643',
            code: 'RU-NVS',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Novosibirskaja oblast'",
            },
        },
        'RU-OMS': {
            numericCode: '643',
            code: 'RU-OMS',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Omskaja oblast'",
            },
        },
        'RU-ORE': {
            numericCode: '643',
            code: 'RU-ORE',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Orenburgskaya oblast'",
            },
        },
        'RU-ORL': {
            numericCode: '643',
            code: 'RU-ORL',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Orlovskaya oblast'",
            },
        },
        'RU-PNZ': {
            numericCode: '643',
            code: 'RU-PNZ',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Penzenskaja oblast'",
            },
        },
        'RU-PSK': {
            numericCode: '643',
            code: 'RU-PSK',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Pskovskaya oblast'",
            },
        },
        'RU-ROS': {
            numericCode: '643',
            code: 'RU-ROS',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Rostovskaya oblast'",
            },
        },
        'RU-RYA': {
            numericCode: '643',
            code: 'RU-RYA',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Ryazanskaya oblast'",
            },
        },
        'RU-SAK': {
            numericCode: '643',
            code: 'RU-SAK',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Sakhalinskaya oblast'",
            },
        },
        'RU-SAM': {
            numericCode: '643',
            code: 'RU-SAM',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Samarskaja oblast'",
            },
        },
        'RU-SAR': {
            numericCode: '643',
            code: 'RU-SAR',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Saratovskaja oblast'",
            },
        },
        'RU-SMO': {
            numericCode: '643',
            code: 'RU-SMO',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Smolenskaya oblast'",
            },
        },
        'RU-SVE': {
            numericCode: '643',
            code: 'RU-SVE',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Sverdlovskaja oblast'",
            },
        },
        'RU-TAM': {
            numericCode: '643',
            code: 'RU-TAM',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Tambovskaja oblast'",
            },
        },
        'RU-TOM': {
            numericCode: '643',
            code: 'RU-TOM',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Tomskaja oblast'",
            },
        },
        'RU-TUL': {
            numericCode: '643',
            code: 'RU-TUL',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Tul'skaya oblast'",
            },
        },
        'RU-TVE': {
            numericCode: '643',
            code: 'RU-TVE',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Tverskaya oblast'",
            },
        },
        'RU-TYU': {
            numericCode: '643',
            code: 'RU-TYU',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Tjumenskaja oblast'",
            },
        },
        'RU-ULY': {
            numericCode: '643',
            code: 'RU-ULY',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Ul'yanovskaya oblast'",
            },
        },
        'RU-VGG': {
            numericCode: '643',
            code: 'RU-VGG',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Volgogradskaya oblast'",
            },
        },
        'RU-VLA': {
            numericCode: '643',
            code: 'RU-VLA',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Vladimirskaja oblast'",
            },
        },
        'RU-VLG': {
            numericCode: '643',
            code: 'RU-VLG',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Vologodskaja oblast'",
            },
        },
        'RU-VOR': {
            numericCode: '643',
            code: 'RU-VOR',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Voronezhskaya oblast'",
            },
        },
        'RU-YAR': {
            numericCode: '643',
            code: 'RU-YAR',
            category: {
                id: '290',
                names: {
                    en: {
                        singular: 'administrative region',
                        plural: 'administrative regions',
                    },
                    fr: {
                        singular: 'région administrative',
                        plural: '',
                    },
                    ru: {
                        singular: "oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Yaroslavskaya oblast'",
            },
        },
        'RU-CHU': {
            numericCode: '643',
            code: 'RU-CHU',
            category: {
                id: '309',
                names: {
                    en: {
                        singular: 'autonomous district',
                        plural: 'autonomous districts',
                    },
                    fr: {
                        singular: 'district autonome',
                        plural: '',
                    },
                    ru: {
                        singular: 'avtonomnyy okrug',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: 'Čukotskij avtonomnyj okrug',
            },
        },
        'RU-KHM': {
            numericCode: '643',
            code: 'RU-KHM',
            category: {
                id: '309',
                names: {
                    en: {
                        singular: 'autonomous district',
                        plural: 'autonomous districts',
                    },
                    fr: {
                        singular: 'district autonome',
                        plural: '',
                    },
                    ru: {
                        singular: 'avtonomnyy okrug',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: 'Hanty-Mansijskij avtonomnyj okrug',
            },
        },
        'RU-NEN': {
            numericCode: '643',
            code: 'RU-NEN',
            category: {
                id: '309',
                names: {
                    en: {
                        singular: 'autonomous district',
                        plural: 'autonomous districts',
                    },
                    fr: {
                        singular: 'district autonome',
                        plural: '',
                    },
                    ru: {
                        singular: 'avtonomnyy okrug',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: 'Neneckij avtonomnyj okrug',
            },
        },
        'RU-YAN': {
            numericCode: '643',
            code: 'RU-YAN',
            category: {
                id: '309',
                names: {
                    en: {
                        singular: 'autonomous district',
                        plural: 'autonomous districts',
                    },
                    fr: {
                        singular: 'district autonome',
                        plural: '',
                    },
                    ru: {
                        singular: 'avtonomnyy okrug',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: 'Yamalo-Nenetskiy avtonomnyy okrug',
            },
        },
        'RU-MOW': {
            numericCode: '643',
            code: 'RU-MOW',
            category: {
                id: '311',
                names: {
                    en: {
                        singular: 'autonomous city',
                        plural: 'autonomous cities',
                    },
                    fr: {
                        singular: 'ville autonome',
                        plural: '',
                    },
                    ru: {
                        singular: 'avtonomnyy gorod',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: 'Moskva',
            },
        },
        'RU-SPE': {
            numericCode: '643',
            code: 'RU-SPE',
            category: {
                id: '311',
                names: {
                    en: {
                        singular: 'autonomous city',
                        plural: 'autonomous cities',
                    },
                    fr: {
                        singular: 'ville autonome',
                        plural: '',
                    },
                    ru: {
                        singular: 'avtonomnyy gorod',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: 'Sankt-Peterburg',
            },
        },
        'RU-YEV': {
            numericCode: '643',
            code: 'RU-YEV',
            category: {
                id: '355',
                names: {
                    en: {
                        singular: 'autonomous region',
                        plural: 'autonomous regions',
                    },
                    fr: {
                        singular: 'région autonome',
                        plural: '',
                    },
                    ru: {
                        singular: "avtonomnaya oblast'",
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Evrejskaja avtonomnaja oblast'",
            },
        },
        'RU-ALT': {
            numericCode: '643',
            code: 'RU-ALT',
            category: {
                id: '396',
                names: {
                    en: {
                        singular: 'administrative territory',
                        plural: 'administrative territories',
                    },
                    fr: {
                        singular: 'territoire administratif',
                        plural: '',
                    },
                    ru: {
                        singular: 'kray',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: 'Altayskiy kray',
            },
        },
        'RU-KAM': {
            numericCode: '643',
            code: 'RU-KAM',
            category: {
                id: '396',
                names: {
                    en: {
                        singular: 'administrative territory',
                        plural: 'administrative territories',
                    },
                    fr: {
                        singular: 'territoire administratif',
                        plural: '',
                    },
                    ru: {
                        singular: 'kray',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: 'Kamčatskij kraj',
            },
        },
        'RU-KDA': {
            numericCode: '643',
            code: 'RU-KDA',
            category: {
                id: '396',
                names: {
                    en: {
                        singular: 'administrative territory',
                        plural: 'administrative territories',
                    },
                    fr: {
                        singular: 'territoire administratif',
                        plural: '',
                    },
                    ru: {
                        singular: 'kray',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: 'Krasnodarskij kraj',
            },
        },
        'RU-KHA': {
            numericCode: '643',
            code: 'RU-KHA',
            category: {
                id: '396',
                names: {
                    en: {
                        singular: 'administrative territory',
                        plural: 'administrative territories',
                    },
                    fr: {
                        singular: 'territoire administratif',
                        plural: '',
                    },
                    ru: {
                        singular: 'kray',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: 'Habarovskij kraj',
            },
        },
        'RU-KYA': {
            numericCode: '643',
            code: 'RU-KYA',
            category: {
                id: '396',
                names: {
                    en: {
                        singular: 'administrative territory',
                        plural: 'administrative territories',
                    },
                    fr: {
                        singular: 'territoire administratif',
                        plural: '',
                    },
                    ru: {
                        singular: 'kray',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: 'Krasnoyarskiy kray',
            },
        },
        'RU-PER': {
            numericCode: '643',
            code: 'RU-PER',
            category: {
                id: '396',
                names: {
                    en: {
                        singular: 'administrative territory',
                        plural: 'administrative territories',
                    },
                    fr: {
                        singular: 'territoire administratif',
                        plural: '',
                    },
                    ru: {
                        singular: 'kray',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: 'Permskij kraj',
            },
        },
        'RU-PRI': {
            numericCode: '643',
            code: 'RU-PRI',
            category: {
                id: '396',
                names: {
                    en: {
                        singular: 'administrative territory',
                        plural: 'administrative territories',
                    },
                    fr: {
                        singular: 'territoire administratif',
                        plural: '',
                    },
                    ru: {
                        singular: 'kray',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: 'Primorskiy kray',
            },
        },
        'RU-STA': {
            numericCode: '643',
            code: 'RU-STA',
            category: {
                id: '396',
                names: {
                    en: {
                        singular: 'administrative territory',
                        plural: 'administrative territories',
                    },
                    fr: {
                        singular: 'territoire administratif',
                        plural: '',
                    },
                    ru: {
                        singular: 'kray',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Stavropol'skij kraj",
            },
        },
        'RU-ZAB': {
            numericCode: '643',
            code: 'RU-ZAB',
            category: {
                id: '396',
                names: {
                    en: {
                        singular: 'administrative territory',
                        plural: 'administrative territories',
                    },
                    fr: {
                        singular: 'territoire administratif',
                        plural: '',
                    },
                    ru: {
                        singular: 'kray',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: "Zabajkal'skij kraj",
            },
        },
        'RU-AD': {
            numericCode: '643',
            code: 'RU-AD',
            category: {
                id: '433',
                names: {
                    en: {
                        singular: 'republic',
                        plural: 'republics',
                    },
                    fr: {
                        singular: 'république',
                        plural: '',
                    },
                    ru: {
                        singular: 'respublika',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: 'Adygeja, Respublika',
            },
        },
        'RU-AL': {
            numericCode: '643',
            code: 'RU-AL',
            category: {
                id: '433',
                names: {
                    en: {
                        singular: 'republic',
                        plural: 'republics',
                    },
                    fr: {
                        singular: 'république',
                        plural: '',
                    },
                    ru: {
                        singular: 'respublika',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: 'Altay, Respublika',
            },
        },
        'RU-BA': {
            numericCode: '643',
            code: 'RU-BA',
            category: {
                id: '433',
                names: {
                    en: {
                        singular: 'republic',
                        plural: 'republics',
                    },
                    fr: {
                        singular: 'république',
                        plural: '',
                    },
                    ru: {
                        singular: 'respublika',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: 'Bashkortostan, Respublika',
            },
        },
        'RU-BU': {
            numericCode: '643',
            code: 'RU-BU',
            category: {
                id: '433',
                names: {
                    en: {
                        singular: 'republic',
                        plural: 'republics',
                    },
                    fr: {
                        singular: 'république',
                        plural: '',
                    },
                    ru: {
                        singular: 'respublika',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: 'Burjatija, Respublika',
            },
        },
        'RU-CE': {
            numericCode: '643',
            code: 'RU-CE',
            category: {
                id: '433',
                names: {
                    en: {
                        singular: 'republic',
                        plural: 'republics',
                    },
                    fr: {
                        singular: 'république',
                        plural: '',
                    },
                    ru: {
                        singular: 'respublika',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: 'Chechenskaya Respublika',
            },
        },
        'RU-CU': {
            numericCode: '643',
            code: 'RU-CU',
            category: {
                id: '433',
                names: {
                    en: {
                        singular: 'republic',
                        plural: 'republics',
                    },
                    fr: {
                        singular: 'république',
                        plural: '',
                    },
                    ru: {
                        singular: 'respublika',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: 'Chuvashskaya Respublika',
            },
        },
        'RU-DA': {
            numericCode: '643',
            code: 'RU-DA',
            category: {
                id: '433',
                names: {
                    en: {
                        singular: 'republic',
                        plural: 'republics',
                    },
                    fr: {
                        singular: 'république',
                        plural: '',
                    },
                    ru: {
                        singular: 'respublika',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: 'Dagestan, Respublika',
            },
        },
        'RU-IN': {
            numericCode: '643',
            code: 'RU-IN',
            category: {
                id: '433',
                names: {
                    en: {
                        singular: 'republic',
                        plural: 'republics',
                    },
                    fr: {
                        singular: 'république',
                        plural: '',
                    },
                    ru: {
                        singular: 'respublika',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: 'Ingushetiya, Respublika',
            },
        },
        'RU-KB': {
            numericCode: '643',
            code: 'RU-KB',
            category: {
                id: '433',
                names: {
                    en: {
                        singular: 'republic',
                        plural: 'republics',
                    },
                    fr: {
                        singular: 'république',
                        plural: '',
                    },
                    ru: {
                        singular: 'respublika',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: 'Kabardino-Balkarskaja Respublika',
            },
        },
        'RU-KC': {
            numericCode: '643',
            code: 'RU-KC',
            category: {
                id: '433',
                names: {
                    en: {
                        singular: 'republic',
                        plural: 'republics',
                    },
                    fr: {
                        singular: 'république',
                        plural: '',
                    },
                    ru: {
                        singular: 'respublika',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: 'Karačaevo-Čerkesskaja Respublika',
            },
        },
        'RU-KK': {
            numericCode: '643',
            code: 'RU-KK',
            category: {
                id: '433',
                names: {
                    en: {
                        singular: 'republic',
                        plural: 'republics',
                    },
                    fr: {
                        singular: 'république',
                        plural: '',
                    },
                    ru: {
                        singular: 'respublika',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: 'Khakasiya, Respublika',
            },
        },
        'RU-KL': {
            numericCode: '643',
            code: 'RU-KL',
            category: {
                id: '433',
                names: {
                    en: {
                        singular: 'republic',
                        plural: 'republics',
                    },
                    fr: {
                        singular: 'république',
                        plural: '',
                    },
                    ru: {
                        singular: 'respublika',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: 'Kalmykiya, Respublika',
            },
        },
        'RU-KO': {
            numericCode: '643',
            code: 'RU-KO',
            category: {
                id: '433',
                names: {
                    en: {
                        singular: 'republic',
                        plural: 'republics',
                    },
                    fr: {
                        singular: 'république',
                        plural: '',
                    },
                    ru: {
                        singular: 'respublika',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: 'Komi, Respublika',
            },
        },
        'RU-KR': {
            numericCode: '643',
            code: 'RU-KR',
            category: {
                id: '433',
                names: {
                    en: {
                        singular: 'republic',
                        plural: 'republics',
                    },
                    fr: {
                        singular: 'république',
                        plural: '',
                    },
                    ru: {
                        singular: 'respublika',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: 'Karelija, Respublika',
            },
        },
        'RU-ME': {
            numericCode: '643',
            code: 'RU-ME',
            category: {
                id: '433',
                names: {
                    en: {
                        singular: 'republic',
                        plural: 'republics',
                    },
                    fr: {
                        singular: 'république',
                        plural: '',
                    },
                    ru: {
                        singular: 'respublika',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: 'Marij Èl, Respublika',
            },
        },
        'RU-MO': {
            numericCode: '643',
            code: 'RU-MO',
            category: {
                id: '433',
                names: {
                    en: {
                        singular: 'republic',
                        plural: 'republics',
                    },
                    fr: {
                        singular: 'république',
                        plural: '',
                    },
                    ru: {
                        singular: 'respublika',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: 'Mordovija, Respublika',
            },
        },
        'RU-SA': {
            numericCode: '643',
            code: 'RU-SA',
            category: {
                id: '433',
                names: {
                    en: {
                        singular: 'republic',
                        plural: 'republics',
                    },
                    fr: {
                        singular: 'république',
                        plural: '',
                    },
                    ru: {
                        singular: 'respublika',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: 'Sakha, Respublika',
            },
        },
        'RU-SE': {
            numericCode: '643',
            code: 'RU-SE',
            category: {
                id: '433',
                names: {
                    en: {
                        singular: 'republic',
                        plural: 'republics',
                    },
                    fr: {
                        singular: 'république',
                        plural: '',
                    },
                    ru: {
                        singular: 'respublika',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: 'Severnaja Osetija, Respublika',
            },
        },
        'RU-TA': {
            numericCode: '643',
            code: 'RU-TA',
            category: {
                id: '433',
                names: {
                    en: {
                        singular: 'republic',
                        plural: 'republics',
                    },
                    fr: {
                        singular: 'république',
                        plural: '',
                    },
                    ru: {
                        singular: 'respublika',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: 'Tatarstan, Respublika',
            },
        },
        'RU-TY': {
            numericCode: '643',
            code: 'RU-TY',
            category: {
                id: '433',
                names: {
                    en: {
                        singular: 'republic',
                        plural: 'republics',
                    },
                    fr: {
                        singular: 'république',
                        plural: '',
                    },
                    ru: {
                        singular: 'respublika',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: 'Tyva, Respublika',
            },
        },
        'RU-UD': {
            numericCode: '643',
            code: 'RU-UD',
            category: {
                id: '433',
                names: {
                    en: {
                        singular: 'republic',
                        plural: 'republics',
                    },
                    fr: {
                        singular: 'république',
                        plural: '',
                    },
                    ru: {
                        singular: 'respublika',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ru: 'Udmurtskaja Respublika',
            },
        },
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUlUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY291bnRyaWVzL2RhdGEvUlUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7O0dBSUc7OztBQU1VLFFBQUEsRUFBRSxHQUFZO0lBQ3ZCLFdBQVcsRUFBRSxLQUFLO0lBQ2xCLFVBQVUsRUFBRSxJQUFJO0lBQ2hCLFVBQVUsRUFBRSxLQUFLO0lBQ2pCLFdBQVcsRUFBRTtRQUNULEtBQUssRUFBRSwwQkFBMEI7UUFDakMsSUFBSSxFQUFFLHdCQUF3QjtLQUNqQztJQUNELEtBQUssRUFBRTtRQUNILElBQUksRUFBRTtZQUNGLEVBQUUsRUFBRSx3QkFBd0I7WUFDNUIsRUFBRSxFQUFFLHlCQUF5QjtZQUM3QixFQUFFLEVBQUUsd0JBQXdCO1NBQy9CO1FBQ0QsS0FBSyxFQUFFO1lBQ0gsRUFBRSxFQUFFLDBCQUEwQjtZQUM5QixFQUFFLEVBQUUsMkJBQTJCO1lBQy9CLEVBQUUsRUFBRSx3QkFBd0I7U0FDL0I7S0FDSjtJQUNELFNBQVMsRUFBRTtRQUNQO1lBQ0ksa0JBQWtCLEVBQUUsSUFBSTtZQUN4QixrQkFBa0IsRUFBRSxLQUFLO1lBQ3pCLGdCQUFnQixFQUFFLEtBQUs7U0FDMUI7UUFDRDtZQUNJLGtCQUFrQixFQUFFLElBQUk7WUFDeEIsa0JBQWtCLEVBQUUsS0FBSztZQUN6QixnQkFBZ0IsRUFBRSxLQUFLO1NBQzFCO1FBQ0Q7WUFDSSxrQkFBa0IsRUFBRSxJQUFJO1lBQ3hCLGtCQUFrQixFQUFFLEtBQUs7WUFDekIsZ0JBQWdCLEVBQUUsSUFBSTtTQUN6QjtLQUNKO0lBQ0QsWUFBWSxFQUFFO1FBQ1YsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLG1CQUFtQjthQUMxQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHdCQUF3QjthQUMvQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHVCQUF1QjthQUM5QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHVCQUF1QjthQUM5QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLG9CQUFvQjthQUMzQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHdCQUF3QjthQUMvQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLG9CQUFvQjthQUMzQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHFCQUFxQjthQUM1QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHNCQUFzQjthQUM3QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLDBCQUEwQjthQUNqQztTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHFCQUFxQjthQUM1QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLG9CQUFvQjthQUMzQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHFCQUFxQjthQUM1QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHNCQUFzQjthQUM3QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGtCQUFrQjthQUN6QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHdCQUF3QjthQUMvQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLG9CQUFvQjthQUMzQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHNCQUFzQjthQUM3QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHFCQUFxQjthQUM1QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHFCQUFxQjthQUM1QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHVCQUF1QjthQUM5QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHlCQUF5QjthQUNoQztTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHdCQUF3QjthQUMvQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGlCQUFpQjthQUN4QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHVCQUF1QjthQUM5QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLG9CQUFvQjthQUMzQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHFCQUFxQjthQUM1QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLG9CQUFvQjthQUMzQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHFCQUFxQjthQUM1QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHFCQUFxQjthQUM1QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHVCQUF1QjthQUM5QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLG9CQUFvQjthQUMzQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHNCQUFzQjthQUM3QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHFCQUFxQjthQUM1QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHVCQUF1QjthQUM5QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHFCQUFxQjthQUM1QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGtCQUFrQjthQUN6QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLG1CQUFtQjthQUMxQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLG1CQUFtQjthQUMxQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHFCQUFxQjthQUM1QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHVCQUF1QjthQUM5QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHdCQUF3QjthQUMvQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHVCQUF1QjthQUM5QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHNCQUFzQjthQUM3QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHVCQUF1QjthQUM5QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsdUJBQXVCO3dCQUNqQyxNQUFNLEVBQUUsd0JBQXdCO3FCQUNuQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHVCQUF1Qjt3QkFDakMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxTQUFTO3dCQUNuQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHVCQUF1QjthQUM5QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUscUJBQXFCO3dCQUMvQixNQUFNLEVBQUUsc0JBQXNCO3FCQUNqQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxrQkFBa0I7d0JBQzVCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsNEJBQTRCO2FBQ25DO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxxQkFBcUI7d0JBQy9CLE1BQU0sRUFBRSxzQkFBc0I7cUJBQ2pDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGtCQUFrQjt3QkFDNUIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxtQ0FBbUM7YUFDMUM7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLHFCQUFxQjt3QkFDL0IsTUFBTSxFQUFFLHNCQUFzQjtxQkFDakM7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxtQkFBbUI7d0JBQzdCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsa0JBQWtCO3dCQUM1QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLDJCQUEyQjthQUNsQztTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUscUJBQXFCO3dCQUMvQixNQUFNLEVBQUUsc0JBQXNCO3FCQUNqQztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLG1CQUFtQjt3QkFDN0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxrQkFBa0I7d0JBQzVCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsbUNBQW1DO2FBQzFDO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxpQkFBaUI7d0JBQzNCLE1BQU0sRUFBRSxtQkFBbUI7cUJBQzlCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsZ0JBQWdCO3dCQUMxQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGtCQUFrQjt3QkFDNUIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7aUJBQ0o7YUFDSjtZQUNELE1BQU0sRUFBRSxFQUFFO1lBQ1YsS0FBSyxFQUFFO2dCQUNILEVBQUUsRUFBRSxRQUFRO2FBQ2Y7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLFdBQVcsRUFBRSxLQUFLO1lBQ2xCLElBQUksRUFBRSxRQUFRO1lBQ2QsUUFBUSxFQUFFO2dCQUNOLEVBQUUsRUFBRSxLQUFLO2dCQUNULEtBQUssRUFBRTtvQkFDSCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGlCQUFpQjt3QkFDM0IsTUFBTSxFQUFFLG1CQUFtQjtxQkFDOUI7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxnQkFBZ0I7d0JBQzFCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsa0JBQWtCO3dCQUM1QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGlCQUFpQjthQUN4QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsbUJBQW1CO3dCQUM3QixNQUFNLEVBQUUsb0JBQW9CO3FCQUMvQjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLGlCQUFpQjt3QkFDM0IsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxxQkFBcUI7d0JBQy9CLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsZ0NBQWdDO2FBQ3ZDO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSwwQkFBMEI7d0JBQ3BDLE1BQU0sRUFBRSw0QkFBNEI7cUJBQ3ZDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsMEJBQTBCO3dCQUNwQyxNQUFNLEVBQUUsRUFBRTtxQkFDYjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE1BQU07d0JBQ2hCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsZ0JBQWdCO2FBQ3ZCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSwwQkFBMEI7d0JBQ3BDLE1BQU0sRUFBRSw0QkFBNEI7cUJBQ3ZDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsMEJBQTBCO3dCQUNwQyxNQUFNLEVBQUUsRUFBRTtxQkFDYjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE1BQU07d0JBQ2hCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsaUJBQWlCO2FBQ3hCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSwwQkFBMEI7d0JBQ3BDLE1BQU0sRUFBRSw0QkFBNEI7cUJBQ3ZDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsMEJBQTBCO3dCQUNwQyxNQUFNLEVBQUUsRUFBRTtxQkFDYjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE1BQU07d0JBQ2hCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsb0JBQW9CO2FBQzNCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSwwQkFBMEI7d0JBQ3BDLE1BQU0sRUFBRSw0QkFBNEI7cUJBQ3ZDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsMEJBQTBCO3dCQUNwQyxNQUFNLEVBQUUsRUFBRTtxQkFDYjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE1BQU07d0JBQ2hCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsa0JBQWtCO2FBQ3pCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSwwQkFBMEI7d0JBQ3BDLE1BQU0sRUFBRSw0QkFBNEI7cUJBQ3ZDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsMEJBQTBCO3dCQUNwQyxNQUFNLEVBQUUsRUFBRTtxQkFDYjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE1BQU07d0JBQ2hCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsb0JBQW9CO2FBQzNCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixXQUFXLEVBQUUsS0FBSztZQUNsQixJQUFJLEVBQUUsUUFBUTtZQUNkLFFBQVEsRUFBRTtnQkFDTixFQUFFLEVBQUUsS0FBSztnQkFDVCxLQUFLLEVBQUU7b0JBQ0gsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSwwQkFBMEI7d0JBQ3BDLE1BQU0sRUFBRSw0QkFBNEI7cUJBQ3ZDO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsMEJBQTBCO3dCQUNwQyxNQUFNLEVBQUUsRUFBRTtxQkFDYjtvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLE1BQU07d0JBQ2hCLE1BQU0sRUFBRSxFQUFFO3FCQUNiO2lCQUNKO2FBQ0o7WUFDRCxNQUFNLEVBQUUsRUFBRTtZQUNWLEtBQUssRUFBRTtnQkFDSCxFQUFFLEVBQUUsZUFBZTthQUN0QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsMEJBQTBCO3dCQUNwQyxNQUFNLEVBQUUsNEJBQTRCO3FCQUN2QztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLDBCQUEwQjt3QkFDcEMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxNQUFNO3dCQUNoQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGlCQUFpQjthQUN4QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsMEJBQTBCO3dCQUNwQyxNQUFNLEVBQUUsNEJBQTRCO3FCQUN2QztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLDBCQUEwQjt3QkFDcEMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxNQUFNO3dCQUNoQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHFCQUFxQjthQUM1QjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLFFBQVE7WUFDZCxRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsMEJBQTBCO3dCQUNwQyxNQUFNLEVBQUUsNEJBQTRCO3FCQUN2QztvQkFDRCxFQUFFLEVBQUU7d0JBQ0EsUUFBUSxFQUFFLDBCQUEwQjt3QkFDcEMsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxNQUFNO3dCQUNoQixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLG9CQUFvQjthQUMzQjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsWUFBWTt3QkFDdEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxZQUFZO3dCQUN0QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHFCQUFxQjthQUM1QjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsWUFBWTt3QkFDdEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxZQUFZO3dCQUN0QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLG1CQUFtQjthQUMxQjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsWUFBWTt3QkFDdEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxZQUFZO3dCQUN0QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLDJCQUEyQjthQUNsQztTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsWUFBWTt3QkFDdEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxZQUFZO3dCQUN0QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHVCQUF1QjthQUM5QjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsWUFBWTt3QkFDdEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxZQUFZO3dCQUN0QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHlCQUF5QjthQUNoQztTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsWUFBWTt3QkFDdEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxZQUFZO3dCQUN0QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHlCQUF5QjthQUNoQztTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsWUFBWTt3QkFDdEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxZQUFZO3dCQUN0QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHNCQUFzQjthQUM3QjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsWUFBWTt3QkFDdEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxZQUFZO3dCQUN0QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHlCQUF5QjthQUNoQztTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsWUFBWTt3QkFDdEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxZQUFZO3dCQUN0QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGtDQUFrQzthQUN6QztTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsWUFBWTt3QkFDdEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxZQUFZO3dCQUN0QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGtDQUFrQzthQUN6QztTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsWUFBWTt3QkFDdEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxZQUFZO3dCQUN0QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHVCQUF1QjthQUM5QjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsWUFBWTt3QkFDdEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxZQUFZO3dCQUN0QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHVCQUF1QjthQUM5QjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsWUFBWTt3QkFDdEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxZQUFZO3dCQUN0QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGtCQUFrQjthQUN6QjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsWUFBWTt3QkFDdEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxZQUFZO3dCQUN0QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHNCQUFzQjthQUM3QjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsWUFBWTt3QkFDdEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxZQUFZO3dCQUN0QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHNCQUFzQjthQUM3QjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsWUFBWTt3QkFDdEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxZQUFZO3dCQUN0QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHVCQUF1QjthQUM5QjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsWUFBWTt3QkFDdEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxZQUFZO3dCQUN0QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLG1CQUFtQjthQUMxQjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsWUFBWTt3QkFDdEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxZQUFZO3dCQUN0QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLCtCQUErQjthQUN0QztTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsWUFBWTt3QkFDdEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxZQUFZO3dCQUN0QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHVCQUF1QjthQUM5QjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsWUFBWTt3QkFDdEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxZQUFZO3dCQUN0QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLGtCQUFrQjthQUN6QjtTQUNKO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsV0FBVyxFQUFFLEtBQUs7WUFDbEIsSUFBSSxFQUFFLE9BQU87WUFDYixRQUFRLEVBQUU7Z0JBQ04sRUFBRSxFQUFFLEtBQUs7Z0JBQ1QsS0FBSyxFQUFFO29CQUNILEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsVUFBVTt3QkFDcEIsTUFBTSxFQUFFLFdBQVc7cUJBQ3RCO29CQUNELEVBQUUsRUFBRTt3QkFDQSxRQUFRLEVBQUUsWUFBWTt3QkFDdEIsTUFBTSxFQUFFLEVBQUU7cUJBQ2I7b0JBQ0QsRUFBRSxFQUFFO3dCQUNBLFFBQVEsRUFBRSxZQUFZO3dCQUN0QixNQUFNLEVBQUUsRUFBRTtxQkFDYjtpQkFDSjthQUNKO1lBQ0QsTUFBTSxFQUFFLEVBQUU7WUFDVixLQUFLLEVBQUU7Z0JBQ0gsRUFBRSxFQUFFLHdCQUF3QjthQUMvQjtTQUNKO0tBQ0o7Q0FDSixDQUFBIn0=